// src/components/KVKKPolicy.jsx
import React from 'react';
import { X, Shield, Eye, Lock, Database, Users, FileText, AlertCircle, CheckCircle } from 'lucide-react';

export function KVKKModal({ isOpen, onClose }) {
    if (!isOpen) return null;

    const companyInfo = {
    name: "Trona Gıda Pazarlama Limited Şirketi",
    address: "Emek Mah. 3022 Sk. No: 2A Manavgat / Antalya",
    phone: "0535 643 41 81",
    email: "info@tronapazarlama.com",
    website: "https://tronapazarlama.com",
    mersis: "0859111653600001",
    tradeRegistryNo: "12847",
    taxOffice: "Manavgat Vergi Dairesi",
    taxNo: "8591116536",
    owner: "Ömer Şahin"
  };

    return (
        <div className="kvkk-modal-overlay" onClick={onClose}>
            <div className="kvkk-modal-content" onClick={e => e.stopPropagation()}>
                <button className="modal-close-btn" onClick={onClose}>
                    <X size={16} />
                </button>

                <div className="kvkk-modal-body">
                    <div className="kvkk-document">
                        <div className="document-header">
                            <Shield size={40} className="header-icon" />
                            <h1>KİŞİSEL VERİLERİN KORUNMASI VE İŞLENMESİ HAKKINDA AYDINLATMA METNİ</h1>
                            <p className="document-date">
                                6698 Sayılı Kişisel Verilerin Korunması Kanunu Uyarınca
                            </p>
                            <p className="document-date">
                                Son Güncelleme: {new Date().toLocaleDateString('tr-TR')}
                            </p>
                        </div>

                        {/* Giriş */}
                        <section className="kvkk-section intro-section">
                            <div className="intro-box">
                                <AlertCircle size={20} />
                                <div>
                                    <p>
                                        <strong>{companyInfo.name}</strong> olarak, 6698 sayılı Kişisel Verilerin
                                        Korunması Kanunu ("KVKK") uyarınca veri sorumlusu sıfatıyla, kişisel verilerinizin
                                        işlenmesine ilişkin olarak siz değerli müşterilerimizi ve web sitemizi ziyaret
                                        eden kullanıcıları bilgilendirmek isteriz.
                                    </p>
                                </div>
                            </div>
                        </section>

                        {/* 1. Veri Sorumlusu */}
                        <section className="kvkk-section">
                            <div className="section-icon-header">
                                <Users size={24} />
                                <h2>1. VERİ SORUMLUSU</h2>
                            </div>

                            <p>
                                Kişisel verileriniz, veri sorumlusu sıfatıyla <strong>{companyInfo.name} </strong>
                                tarafından aşağıda açıklanan kapsamda işlenmektedir.
                            </p>

                            <div className="info-card">
                                <h3>İletişim Bilgilerimiz:</h3>
                                <div className="contact-grid">
                                    <div className="contact-item">
                                        <strong>Ünvan:</strong>
                                        <span>{companyInfo.name}</span>
                                    </div>
                                    <div className="contact-item">
                                        <strong>Adres:</strong>
                                        <span>{companyInfo.address}</span>
                                    </div>
                                    <div className="contact-item">
                                        <strong>MERSİS No:</strong>
                                        <span>{companyInfo.mersis}</span>
                                    </div>
                                    <div className="contact-item">
                                        <strong>Telefon:</strong>
                                        <span>{companyInfo.phone}</span>
                                    </div>
                                    <div className="contact-item">
                                        <strong>E-posta:</strong>
                                        <span>{companyInfo.email}</span>
                                    </div>
                                    <div className="contact-item">
                                        <strong>Web Sitesi:</strong>
                                        <span>{companyInfo.website}</span>
                                    </div>
                                </div>
                            </div>
                        </section>

                        {/* 2. Hangi Kişisel Veriler İşlenmektedir */}
                        <section className="kvkk-section">
                            <div className="section-icon-header">
                                <Database size={24} />
                                <h2>2. HANGİ KİŞİSEL VERİLERİNİZ İŞLENMEKTEDİR?</h2>
                            </div>

                            <p>
                                Elektronik ticaret faaliyetlerimiz kapsamında aşağıdaki kişisel verileriniz
                                işlenebilmektedir:
                            </p>

                            <div className="data-categories">
                                <div className="data-category-card">
                                    <div className="category-header">
                                        <CheckCircle size={18} />
                                        <h3>Kimlik Bilgileri</h3>
                                    </div>
                                    <ul>
                                        <li>Ad, Soyad</li>
                                        <li>T.C. Kimlik Numarası (isteğe bağlı, fatura için)</li>
                                        <li>Doğum Tarihi (isteğe bağlı)</li>
                                    </ul>
                                </div>

                                <div className="data-category-card">
                                    <div className="category-header">
                                        <CheckCircle size={18} />
                                        <h3>İletişim Bilgileri</h3>
                                    </div>
                                    <ul>
                                        <li>E-posta Adresi</li>
                                        <li>Telefon Numarası</li>
                                        <li>Adres Bilgisi (teslimat ve fatura adresi)</li>
                                    </ul>
                                </div>

                                <div className="data-category-card">
                                    <div className="category-header">
                                        <CheckCircle size={18} />
                                        <h3>Müşteri İşlem Bilgileri</h3>
                                    </div>
                                    <ul>
                                        <li>Sipariş Bilgileri</li>
                                        <li>Satın Alınan Ürün/Hizmet Bilgileri</li>
                                        <li>Fatura Bilgileri</li>
                                        <li>Ödeme Bilgileri (kart bilgileri 3D Secure ile korunur)</li>
                                        <li>Kargo Takip Bilgileri</li>
                                    </ul>
                                </div>

                                <div className="data-category-card">
                                    <div className="category-header">
                                        <CheckCircle size={18} />
                                        <h3>İşlem Güvenliği Bilgileri</h3>
                                    </div>
                                    <ul>
                                        <li>IP Adresi</li>
                                        <li>Çerez (Cookie) Bilgileri</li>
                                        <li>Cihaz ve Tarayıcı Bilgileri</li>
                                        <li>Site İçi Hareket Bilgileri</li>
                                    </ul>
                                </div>

                                <div className="data-category-card">
                                    <div className="category-header">
                                        <CheckCircle size={18} />
                                        <h3>Pazarlama Bilgileri</h3>
                                    </div>
                                    <ul>
                                        <li>Alışveriş Tercihleri</li>
                                        <li>Beğeniler ve Favoriler</li>
                                        <li>Kampanya ve İndirim Tercihleri</li>
                                        <li>Sepet ve Görüntüleme Geçmişi</li>
                                    </ul>
                                </div>

                                <div className="data-category-card">
                                    <div className="category-header">
                                        <CheckCircle size={18} />
                                        <h3>Hukuki İşlem Bilgileri</h3>
                                    </div>
                                    <ul>
                                        <li>İade ve İptal Talepleri</li>
                                        <li>Şikayet ve Öneri Kayıtları</li>
                                        <li>Çağrı Merkezi Kayıtları</li>
                                        <li>Sözleşme Onay Kayıtları</li>
                                    </ul>
                                </div>
                            </div>

                            <div className="important-note">
                                <Lock size={20} />
                                <div>
                                    <h4>Önemli Not:</h4>
                                    <p>
                                        Kredi kartı bilgileriniz hiçbir şekilde sistemimizde saklanmamaktadır.
                                        Tüm ödeme işlemleri 3D Secure teknolojisi ile güvenli ödeme altyapısı
                                        üzerinden gerçekleştirilmektedir. Sadece son 4 hane kart numarası ve
                                        kart markası bilgisi işlem kaydı için tutulmaktadır.
                                    </p>
                                </div>
                            </div>
                        </section>

                        {/* 3. Kişisel Verilerin İşlenme Amaçları */}
                        <section className="kvkk-section">
                            <div className="section-icon-header">
                                <Eye size={24} />
                                <h2>3. KİŞİSEL VERİLERİNİZ NEDEN VE NASIL İŞLENMEKTEDİR?</h2>
                            </div>

                            <p>Kişisel verileriniz aşağıdaki amaçlarla işlenmektedir:</p>

                            <div className="purpose-list">
                                <div className="purpose-item">
                                    <div className="purpose-number">1</div>
                                    <div className="purpose-content">
                                        <h3>Sözleşme ve Hizmet İfası</h3>
                                        <p>
                                            Elektronik ticaret faaliyetlerimizin yürütülmesi, sipariş ve teslimat
                                            süreçlerinin gerçekleştirilmesi, satış sözleşmesinin ifası, müşteri
                                            memnuniyetinin sağlanması.
                                        </p>
                                    </div>
                                </div>

                                <div className="purpose-item">
                                    <div className="purpose-number">2</div>
                                    <div className="purpose-content">
                                        <h3>Yasal Yükümlülüklerin Yerine Getirilmesi</h3>
                                        <p>
                                            Vergi mevzuatı, e-ticaret mevzuatı, tüketici mevzuatı ve diğer yasal
                                            düzenlemeler gereği fatura kesme, kayıt tutma ve raporlama yükümlülüklerinin
                                            yerine getirilmesi.
                                        </p>
                                    </div>
                                </div>

                                <div className="purpose-item">
                                    <div className="purpose-number">3</div>
                                    <div className="purpose-content">
                                        <h3>Müşteri İlişkileri Yönetimi</h3>
                                        <p>
                                            Müşteri hizmetleri süreçlerinin yürütülmesi, talep, öneri ve şikayetlerin
                                            değerlendirilmesi, müşteri memnuniyeti anketlerinin yapılması.
                                        </p>
                                    </div>
                                </div>

                                <div className="purpose-item">
                                    <div className="purpose-number">4</div>
                                    <div className="purpose-content">
                                        <h3>Pazarlama Faaliyetleri</h3>
                                        <p>
                                            Açık rızanız dahilinde, kampanya ve promosyonlardan haberdar edilmeniz,
                                            kişiselleştirilmiş tekliflerin sunulması, yeni ürün ve hizmetlerin tanıtılması.
                                        </p>
                                    </div>
                                </div>

                                <div className="purpose-item">
                                    <div className="purpose-number">5</div>
                                    <div className="purpose-content">
                                        <h3>Güvenlik ve Dolandırıcılık Önleme</h3>
                                        <p>
                                            Sistemlerimizin güvenliğinin sağlanması, dolandırıcılık faaliyetlerinin
                                            önlenmesi, hukuki uyuşmazlıklarda delil oluşturulması.
                                        </p>
                                    </div>
                                </div>

                                <div className="purpose-item">
                                    <div className="purpose-number">6</div>
                                    <div className="purpose-content">
                                        <h3>İstatistik ve Analiz</h3>
                                        <p>
                                            İş geliştirme faaliyetlerinin planlanması, hizmet kalitesinin artırılması,
                                            web sitesi performansının iyileştirilmesi amacıyla istatistiksel analizler.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </section>

                        {/* 4. Hukuki Sebepler */}
                        <section className="kvkk-section">
                            <div className="section-icon-header">
                                <FileText size={24} />
                                <h2>4. KİŞİSEL VERİLERİN İŞLENMESİNİN HUKUKİ SEBEPLERİ</h2>
                            </div>

                            <p>
                                Kişisel verileriniz KVKK'nın 5. ve 6. maddelerinde belirtilen aşağıdaki
                                hukuki sebeplere dayanılarak işlenmektedir:
                            </p>

                            <div className="legal-bases">
                                <div className="legal-base-card">
                                    <h3>📋 Kanunlarda Açıkça Öngörülmesi</h3>
                                    <p>
                                        Vergi Usul Kanunu, E-Ticaret Kanunu, Tüketicinin Korunması Hakkında Kanun
                                        gibi mevzuatta öngörülen yasal yükümlülükler.
                                    </p>
                                </div>

                                <div className="legal-base-card">
                                    <h3>📝 Sözleşmenin Kurulması veya İfası</h3>
                                    <p>
                                        Sizinle yapılan satış sözleşmesinin kurulması ve ifası için gerekli olması.
                                    </p>
                                </div>

                                <div className="legal-base-card">
                                    <h3>⚖️ Hukuki Yükümlülüğün Yerine Getirilmesi</h3>
                                    <p>
                                        Yasal yükümlülüklerimizin yerine getirilmesi için zorunlu olması.
                                    </p>
                                </div>

                                <div className="legal-base-card">
                                    <h3>✅ Açık Rıza</h3>
                                    <p>
                                        Pazarlama faaliyetleri gibi durumlarda sizden alınan açık rızanız.
                                    </p>
                                </div>

                                <div className="legal-base-card">
                                    <h3>🎯 Meşru Menfaat</h3>
                                    <p>
                                        İşletmemizin meşru menfaatleri için veri işlemenin zorunlu olması
                                        (güvenlik, istatistik, analiz).
                                    </p>
                                </div>
                            </div>
                        </section>

                        {/* 5. Kişisel Verilerin Aktarımı */}
                        <section className="kvkk-section">
                            <div className="section-icon-header">
                                <Users size={24} />
                                <h2>5. KİŞİSEL VERİLERİNİZ KİMLERE VE HANGİ AMAÇLARLA AKTARILABİLİR?</h2>
                            </div>

                            <p>
                                Kişisel verileriniz, KVKK'nın 8. ve 9. maddelerinde belirtilen kişisel veri
                                işleme şartları ve amaçları dahilinde aşağıdaki taraflara aktarılabilmektedir:
                            </p>

                            <div className="transfer-table">
                                <div className="transfer-row header-row">
                                    <div className="transfer-cell">Aktarım Yapılan Taraf</div>
                                    <div className="transfer-cell">Aktarım Amacı</div>
                                </div>

                                <div className="transfer-row">
                                    <div className="transfer-cell">
                                        <strong>Kargo Firmaları</strong>
                                    </div>
                                    <div className="transfer-cell">
                                        Siparişlerinizin teslimatının gerçekleştirilmesi
                                    </div>
                                </div>

                                <div className="transfer-row">
                                    <div className="transfer-cell">
                                        <strong>Ödeme Kuruluşları ve Bankalar</strong>
                                    </div>
                                    <div className="transfer-cell">
                                        Ödeme işlemlerinin güvenli bir şekilde gerçekleştirilmesi
                                    </div>
                                </div>

                                <div className="transfer-row">
                                    <div className="transfer-cell">
                                        <strong>Bulut Hizmet Sağlayıcıları</strong>
                                    </div>
                                    <div className="transfer-cell">
                                        Sistemlerimizin çalışması ve veri saklama hizmetleri (Firebase, AWS vb.)
                                    </div>
                                </div>

                                <div className="transfer-row">
                                    <div className="transfer-cell">
                                        <strong>Muhasebe ve Mali Müşavirlik Firmaları</strong>
                                    </div>
                                    <div className="transfer-cell">
                                        Mali işlemlerin yürütülmesi ve yasal yükümlülüklerin yerine getirilmesi
                                    </div>
                                </div>

                                <div className="transfer-row">
                                    <div className="transfer-cell">
                                        <strong>Hukuk Firmaları</strong>
                                    </div>
                                    <div className="transfer-cell">
                                        Hukuki danışmanlık alınması ve dava süreçlerinin yürütülmesi
                                    </div>
                                </div>

                                <div className="transfer-row">
                                    <div className="transfer-cell">
                                        <strong>Yetkili Kamu Kurum ve Kuruluşları</strong>
                                    </div>
                                    <div className="transfer-cell">
                                        Yasal yükümlülükler çerçevesinde talep edilmesi halinde
                                    </div>
                                </div>

                                <div className="transfer-row">
                                    <div className="transfer-cell">
                                        <strong>Pazarlama Hizmet Sağlayıcıları</strong>
                                    </div>
                                    <div className="transfer-cell">
                                        Açık rızanız dahilinde pazarlama faaliyetlerinin yürütülmesi
                                    </div>
                                </div>
                            </div>

                            <div className="warning-box">
                                <AlertCircle size={20} />
                                <div>
                                    <h4>Yurt Dışına Veri Aktarımı:</h4>
                                    <p>
                                        Bulut hizmet sağlayıcıları (Firebase/Google, AWS vb.) kullanımı nedeniyle
                                        kişisel verileriniz yurt dışına aktarılabilmektedir. Bu aktarımlar KVKK'nın
                                        9. maddesi uyarınca ve yeterli koruma sağlayan ülkelere/firmalara yapılmaktadır.
                                        Ayrıca açık rızanız alınmaktadır.
                                    </p>
                                </div>
                            </div>
                        </section>

                        {/* 6. Veri Toplama Yöntemleri */}
                        <section className="kvkk-section">
                            <div className="section-icon-header">
                                <Database size={24} />
                                <h2>6. KİŞİSEL VERİLERİNİZ NASIL TOPLANMAKTADIR?</h2>
                            </div>

                            <div className="collection-methods">
                                <div className="method-card">
                                    <h3>🌐 Web Sitesi</h3>
                                    <p>
                                        Üyelik, sipariş, iletişim formları, çerezler aracılığıyla otomatik olarak
                                    </p>
                                </div>

                                <div className="method-card">
                                    <h3>📱 Mobil Uygulama</h3>
                                    <p>
                                        Mobil uygulamamız üzerinden yapılan işlemler
                                    </p>
                                </div>

                                <div className="method-card">
                                    <h3>📞 Çağrı Merkezi</h3>
                                    <p>
                                        Müşteri hizmetleri ile yapılan görüşmeler (kayıtlar tutulabilir)
                                    </p>
                                </div>

                                <div className="method-card">
                                    <h3>📧 E-posta</h3>
                                    <p>
                                        E-posta yoluyla yapılan yazışmalar
                                    </p>
                                </div>

                                <div className="method-card">
                                    <h3>💬 Sosyal Medya</h3>
                                    <p>
                                        Sosyal medya hesaplarımız üzerinden alınan mesajlar
                                    </p>
                                </div>

                                <div className="method-card">
                                    <h3>🤝 Fiziksel Ortam</h3>
                                    <p>
                                        Mağaza veya ofislerimizde doldurulan formlar (varsa)
                                    </p>
                                </div>
                            </div>
                        </section>

                        {/* 7. Kişisel Veri Sahibinin Hakları */}
                        <section className="kvkk-section highlight-section">
                            <div className="section-icon-header">
                                <Shield size={24} />
                                <h2>7. KİŞİSEL VERİ SAHİBİ OLARAK HAKLARINIZ</h2>
                            </div>

                            <p>
                                KVKK'nın 11. maddesi uyarınca, kişisel veri sahibi olarak aşağıdaki haklara
                                sahipsiniz:
                            </p>

                            <div className="rights-grid">
                                <div className="right-card">
                                    <div className="right-icon">1</div>
                                    <h3>Bilgi Talep Etme</h3>
                                    <p>
                                        Kişisel verilerinizin işlenip işlenmediğini öğrenme
                                    </p>
                                </div>

                                <div className="right-card">
                                    <div className="right-icon">2</div>
                                    <h3>Bilgi İsteme</h3>
                                    <p>
                                        İşlenmişse buna ilişkin bilgi talep etme
                                    </p>
                                </div>

                                <div className="right-card">
                                    <div className="right-icon">3</div>
                                    <h3>Amaç Öğrenme</h3>
                                    <p>
                                        Kişisel verilerin işlenme amacını ve bunların amacına uygun kullanılıp
                                        kullanılmadığını öğrenme
                                    </p>
                                </div>

                                <div className="right-card">
                                    <div className="right-icon">4</div>
                                    <h3>Aktarım Bilgisi</h3>
                                    <p>
                                        Yurt içinde veya yurt dışında kişisel verilerin aktarıldığı üçüncü kişileri
                                        bilme
                                    </p>
                                </div>

                                <div className="right-card">
                                    <div className="right-icon">5</div>
                                    <h3>Düzeltme Talebi</h3>
                                    <p>
                                        Kişisel verilerin eksik veya yanlış işlenmiş olması halinde bunların
                                        düzeltilmesini isteme
                                    </p>
                                </div>

                                <div className="right-card">
                                    <div className="right-icon">6</div>
                                    <h3>Silme/Yok Etme</h3>
                                    <p>
                                        KVKK'nın 7. maddesinde öngörülen şartlar çerçevesinde kişisel verilerinizin
                                        silinmesini veya yok edilmesini isteme
                                    </p>
                                </div>

                                <div className="right-card">
                                    <div className="right-icon">7</div>
                                    <h3>Bildirim Talebi</h3>
                                    <p>
                                        Düzeltme, silme veya yok edilme işlemlerinin kişisel verilerin aktarıldığı
                                        üçüncü kişilere bildirilmesini isteme
                                    </p>
                                </div>

                                <div className="right-card">
                                    <div className="right-icon">8</div>
                                    <h3>İtiraz Etme</h3>
                                    <p>
                                        İşlenen verilerin münhasıran otomatik sistemler vasıtasıyla analiz edilmesi
                                        suretiyle aleyhinize bir sonuç doğması durumunda buna itiraz etme
                                    </p>
                                </div>

                                <div className="right-card">
                                    <div className="right-icon">9</div>
                                    <h3>Tazminat Talebi</h3>
                                    <p>
                                        Kişisel verilerinizin kanuna aykırı olarak işlenmesi sebebiyle zarara
                                        uğramanız halinde zararın giderilmesini talep etme
                                    </p>
                                </div>
                            </div>
                        </section>

                        {/* 8. Başvuru Yöntemi */}
                        <section className="kvkk-section">
                            <div className="section-icon-header">
                                <FileText size={24} />
                                <h2>8. HAKLARINIZI NASIL KULLANABİLİRSİNİZ?</h2>
                            </div>

                            <p>
                                Yukarıda belirtilen haklarınızı kullanmak için aşağıdaki yöntemlerle
                                başvuruda bulunabilirsiniz:
                            </p>

                            <div className="application-methods">
                                <div className="application-card">
                                    <h3>📧 E-posta ile Başvuru</h3>
                                    <p>
                                        <strong>E-posta:</strong> {companyInfo.email}
                                    </p>
                                    <p className="note">
                                        Başvurunuzu kayıtlı e-posta adresinizden veya başvuru formunu imzalayarak
                                        gönderebilirsiniz.
                                    </p>
                                </div>

                                <div className="application-card">
                                    <h3>✉️ Posta ile Başvuru</h3>
                                    <p>
                                        <strong>Adres:</strong> {companyInfo.address}
                                    </p>
                                    <p className="note">
                                        "Kişisel Verilerin Korunması Kanunu Bilgi Talebi" yazılı zarfla
                                        gönderebilirsiniz.
                                    </p>
                                </div>

                                <div className="application-card">
                                    <h3>🖊️ Başvuru Formu</h3>
                                    <p>
                                        Web sitemizden <a href="/kvkk-basvuru-formu" target="_blank">KVKK Başvuru Formu</a>'nu
                                        indirerek doldurabilir ve yukarıdaki yöntemlerle gönderebilirsiniz.
                                    </p>
                                </div>
                            </div>

                            <div className="important-note">
                                <AlertCircle size={20} />
                                <div>
                                    <h4>Başvuru Sonuçlandırma Süresi:</h4>
                                    <p>
                                        Başvurularınız, niteliğine göre en kısa sürede ve en geç <strong>30 (otuz) gün</strong>
                                        içinde ücretsiz olarak sonuçlandırılacaktır. İşlemin ayrıca bir maliyeti
                                        gerektirmesi halinde, Kişisel Verileri Koruma Kurulu tarafından belirlenen
                                        tarifedeki ücret talep edilebilir.
                                    </p>
                                </div>
                            </div>
                        </section>

                        {/* 9. Veri Güvenliği */}
                        <section className="kvkk-section">
                            <div className="section-icon-header">
                                <Lock size={24} />
                                <h2>9. KİŞİSEL VERİLERİNİZİN GÜVENLİĞİ</h2>
                            </div>

                            <p>
                                Kişisel verilerinizin güvenliğini sağlamak için KVKK'nın 12. maddesi uyarınca
                                aşağıdaki teknik ve idari tedbirleri almaktayız:
                            </p>

                            <div className="security-measures">
                                <div className="security-item">
                                    <Lock size={20} />
                                    <div>
                                        <h3>SSL/TLS Şifreleme</h3>
                                        <p>Web sitemiz 256-bit SSL sertifikası ile korunmaktadır</p>
                                    </div>
                                </div>

                                <div className="security-item">
                                    <Shield size={20} />
                                    <div>
                                        <h3>Güvenli Veri Saklama</h3>
                                        <p>Veriler şifrelenmiş ve güvenli sunucularda saklanmaktadır (Firebase/Firestore)</p>
                                    </div>
                                </div>

                                <div className="security-item">
                                    <Eye size={20} />
                                    <div>
                                        <h3>Erişim Kontrolü</h3>
                                        <p>Verilere erişim yetkilendirme sistemi ile kontrol edilmektedir</p>
                                    </div>
                                </div>

                                <div className="security-item">
                                    <Database size={20} />
                                    <div>
                                        <h3>Düzenli Yedekleme</h3>
                                        <p>Veriler düzenli olarak yedeklenmekte ve felaket kurtarma planları uygulanmaktadır</p>
                                    </div>
                                </div>

                                <div className="security-item">
                                    <FileText size={20} />
                                    <div>
                                        <h3>Çalışan Eğitimleri</h3>
                                        <p>Personelimiz KVKK konusunda düzenli olarak eğitilmektedir</p>
                                    </div>
                                </div>

                                <div className="security-item">
                                    <AlertCircle size={20} />
                                    <div>
                                        <h3>İhlal Bildirimi</h3>
                                        <p>Veri ihlali durumunda yasal süre içinde bildirim yapılmaktadır</p>
                                    </div>
                                </div>
                            </div>
                        </section>

                        {/* 10. Veri Saklama Süreleri */}
                        <section className="kvkk-section">
                            <div className="section-icon-header">
                                <Database size={24} />
                                <h2>10. KİŞİSEL VERİLERİNİZ NE KADAR SAKLANIR?</h2>
                            </div>

                            <p>
                                Kişisel verileriniz, işleme amacının ortadan kalkması ve/veya mevzuatta öngörülen
                                saklama sürelerinin dolması halinde silinir, yok edilir veya anonim hale getirilir.
                            </p>

                            <div className="retention-table">
                                <div className="retention-row header-row">
                                    <div className="retention-cell">Veri Türü</div>
                                    <div className="retention-cell">Saklama Süresi</div>
                                    <div className="retention-cell">Yasal Dayanak</div>
                                </div>

                                <div className="retention-row">
                                    <div className="retention-cell">Fatura ve Mali Belgeler</div>
                                    <div className="retention-cell">10 yıl</div>
                                    <div className="retention-cell">Vergi Usul Kanunu</div>
                                </div>

                                <div className="retention-row">
                                    <div className="retention-cell">Sözleşme ve Sipariş Kayıtları</div>
                                    <div className="retention-cell">10 yıl</div>
                                    <div className="retention-cell">Türk Borçlar Kanunu</div>
                                </div>

                                <div className="retention-row">
                                    <div className="retention-cell">İletişim ve Şikayet Kayıtları</div>
                                    <div className="retention-cell">3 yıl</div>
                                    <div className="retention-cell">Tüketiciyi Koruma Mevzuatı</div>
                                </div>

                                <div className="retention-row">
                                    <div className="retention-cell">Pazarlama İzni Kayıtları</div>
                                    <div className="retention-cell">İzin iptaline kadar</div>
                                    <div className="retention-cell">KVKK</div>
                                </div>

                                <div className="retention-row">
                                    <div className="retention-cell">Web Sitesi Log Kayıtları</div>
                                    <div className="retention-cell">2 yıl</div>
                                    <div className="retention-cell">Elektronik Ticaret Kanunu</div>
                                </div>

                                <div className="retention-row">
                                    <div className="retention-cell">Çerez (Cookie) Verileri</div>
                                    <div className="retention-cell">6 ay - 2 yıl</div>
                                    <div className="retention-cell">Çerez Politikası</div>
                                </div>
                            </div>
                        </section>

                        {/* 11. Çerezler */}
                        <section className="kvkk-section">
                            <div className="section-icon-header">
                                <Eye size={24} />
                                <h2>11. ÇEREZ (COOKIE) POLİTİKASI</h2>
                            </div>

                            <p>
                                Web sitemizde çerezler kullanılmaktadır. Çerezler hakkında detaylı bilgi için
                                <a href="/cerez-politikasi"> Çerez Politikamızı</a> inceleyebilirsiniz.
                            </p>

                            <div className="cookie-info">
                                <h3>Kullanılan Çerez Türleri:</h3>
                                <ul>
                                    <li><strong>Zorunlu Çerezler:</strong> Sitenin çalışması için gerekli</li>
                                    <li><strong>Analitik Çerezler:</strong> Site performansını ölçmek için (Google Analytics)</li>
                                    <li><strong>İşlevsel Çerezler:</strong> Kullanıcı tercihlerini hatırlamak için</li>
                                    <li><strong>Pazarlama Çerezleri:</strong> Reklam gösterimi için (Açık rıza ile)</li>
                                </ul>
                                <p className="note">
                                    Tarayıcınızın ayarlarından çerezleri yönetebilir veya silebilirsiniz.
                                </p>
                            </div>
                        </section>

                        {/* 12. Değişiklikler */}
                        <section className="kvkk-section">
                            <div className="section-icon-header">
                                <AlertCircle size={24} />
                                <h2>12. AYDINLATMA METNİNDE DEĞİŞİKLİKLER</h2>
                            </div>

                            <p>
                                İşbu Aydınlatma Metni, yasal mevzuatta yapılacak değişiklikler veya
                                şirketimizin veri işleme faaliyetlerindeki değişiklikler nedeniyle
                                güncellenebilir. Güncellemeler web sitemizde yayımlandığı tarihte
                                yürürlüğe girer.
                            </p>

                            <div className="update-notice">
                                <AlertCircle size={20} />
                                <p>
                                    Önemli değişiklikler yapıldığında, e-posta veya web sitesi üzerinden
                                    bilgilendirileceksiniz.
                                </p>
                            </div>
                        </section>

                        {/* İletişim */}
                        <section className="kvkk-section contact-section">
                            <div className="section-icon-header">
                                <Users size={24} />
                                <h2>13. İLETİŞİM</h2>
                            </div>

                            <p>
                                Kişisel verilerinizin işlenmesi ile ilgili sorularınız için bizimle
                                iletişime geçebilirsiniz:
                            </p>

                            <div className="final-contact-card">
                                <div className="contact-row">
                                    <strong>Şirket:</strong>
                                    <span>{companyInfo.name}</span>
                                </div>
                                <div className="contact-row">
                                    <strong>Adres:</strong>
                                    <span>{companyInfo.address}</span>
                                </div>
                                <div className="contact-row">
                                    <strong>E-posta:</strong>
                                    <span>{companyInfo.email}</span>
                                </div>
                                <div className="contact-row">
                                    <strong>Telefon:</strong>
                                    <span>{companyInfo.phone}</span>
                                </div>
                                <div className="contact-row">
                                    <strong>Web:</strong>
                                    <span>{companyInfo.website}</span>
                                </div>
                            </div>
                        </section>

                        {/* Footer */}
                        <div className="document-footer">
                            <p>
                                Bu aydınlatma metni, 6698 sayılı Kişisel Verilerin Korunması Kanunu ve
                                ilgili mevzuat uyarınca hazırlanmıştır.
                            </p>
                            <p className="signature">
                                <strong>{companyInfo.name}</strong>
                            </p>
                            <p className="effective-date">
                                Yürürlük Tarihi: {new Date().toLocaleDateString('tr-TR')}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <KVKKStyles />
        </div>
    );
}

// Styles Component
function KVKKStyles() {
    return (
        <style>{`
      .kvkk-modal-overlay {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.75);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 10000;
        padding: 20px;
        animation: fadeIn 0.2s ease;
      }

      .kvkk-modal-content {
        background: #fff;
        border-radius: 20px;
        width: 100%;
        max-width: 1000px;
        max-height: 90vh;
        overflow: hidden;
        box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
        position: relative;
        animation: slideUp 0.3s ease;
      }

      .modal-close-btn {
    position: sticky;
    top: 0;
    right: 0;
    float: right;
    background: #E5332A;
    color: #fff;
    border: none;
    width: 44px;
    height: 44px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    z-index: 10;
    margin: 20px 10px 0 0;
    transition: all 0.2s;
    margin-left: 8px;
  }

  .modal-close-btn:hover {
    background: #c72a22;
    transform: rotate(90deg);
  }

      .kvkk-modal-body {
        overflow-y: auto;
        max-height: calc(90vh - 20px);
        padding: 20px 40px 40px;
      }

      .kvkk-modal-body::-webkit-scrollbar {
        width: 10px;
      }

      .kvkk-modal-body::-webkit-scrollbar-track {
        background: #f1f1f1;
      }

      .kvkk-modal-body::-webkit-scrollbar-thumb {
        background: #E5332A;
        border-radius: 5px;
      }

      .kvkk-document {
        color: #2B2B2B;
        line-height: 1.7;
      }

      .document-header {
        text-align: center;
        padding-bottom: 32px;
        border-bottom: 3px solid #E5332A;
        margin-bottom: 32px;
      }

      .header-icon {
        color: #E5332A;
        margin: 0 auto 16px;
      }

      .document-header h1 {
        font-size: 26px;
        font-weight: 700;
        color: #2B2B2B;
        margin-bottom: 12px;
        line-height: 1.3;
      }

      .document-date {
        font-size: 14px;
        color: #868e96;
        margin-bottom: 4px;
      }

      .kvkk-section {
        margin-bottom: 40px;
      }

      .section-icon-header {
        display: flex;
        align-items: center;
        gap: 12px;
        margin-bottom: 20px;
        padding-bottom: 12px;
        border-bottom: 2px solid #f1f3f5;
      }

      .section-icon-header svg {
        color: #E5332A;
        flex-shrink: 0;
      }

      .section-icon-header h2 {
        font-size: 20px;
        font-weight: 700;
        color: #E5332A;
        margin: 0;
      }

      .kvkk-section h3 {
        font-size: 16px;
        font-weight: 600;
        color: #2B2B2B;
        margin: 20px 0 12px;
      }

      .kvkk-section p {
        margin-bottom: 16px;
        text-align: justify;
        font-size: 15px;
      }

      .kvkk-section ul {
        margin: 16px 0;
        padding-left: 28px;
      }

      .kvkk-section li {
        margin-bottom: 10px;
        line-height: 1.6;
        font-size: 15px;
      }

      .kvkk-section a {
        color: #E5332A;
        text-decoration: underline;
        font-weight: 600;
      }

      .kvkk-section a:hover {
        color: #c72a22;
      }

      /* Intro Section */
      .intro-section {
        background: #f8f9fa;
        padding: 20px;
        border-radius: 12px;
        border-left: 4px solid #E5332A;
      }

      .intro-box {
        display: flex;
        gap: 16px;
      }

      .intro-box svg {
        color: #E5332A;
        flex-shrink: 0;
        margin-top: 4px;
      }

      .intro-box p {
        margin: 0;
      }

      /* Info Cards */
      .info-card {
        background: #f8f9fa;
        padding: 24px;
        border-radius: 12px;
        margin: 20px 0;
      }

      .info-card h3 {
        font-size: 16px;
        margin-bottom: 16px;
        color: #E5332A;
      }

      .contact-grid {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 16px;
      }

      .contact-item {
        display: flex;
        flex-direction: column;
        gap: 6px;
      }

      .contact-item strong {
        font-size: 13px;
        color: #868e96;
        font-weight: 600;
      }

      .contact-item span {
        font-size: 14px;
        color: #2B2B2B;
      }

      /* Data Categories */
      .data-categories {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 16px;
        margin: 24px 0;
      }

      .data-category-card {
        background: #f8f9fa;
        padding: 20px;
        border-radius: 12px;
        border: 2px solid #e9ecef;
      }

      .category-header {
        display: flex;
        align-items: center;
        gap: 8px;
        margin-bottom: 12px;
      }

      .category-header svg {
        color: #22c55e;
        flex-shrink: 0;
      }

      .category-header h3 {
        font-size: 15px;
        margin: 0;
        color: #2B2B2B;
      }

      .data-category-card ul {
        list-style: none;
        padding: 0;
        margin: 0;
      }

      .data-category-card li {
        font-size: 14px;
        margin-bottom: 8px;
        padding-left: 20px;
        position: relative;
      }

      .data-category-card li:before {
        content: "•";
        position: absolute;
        left: 0;
        color: #E5332A;
        font-weight: 700;
      }

      /* Important Note */
      .important-note {
        display: flex;
        gap: 16px;
        background: #fff3e0;
        border-left: 4px solid #ff9800;
        padding: 20px;
        border-radius: 12px;
        margin: 24px 0;
      }

      .important-note svg {
        color: #ff9800;
        flex-shrink: 0;
        margin-top: 4px;
      }

      .important-note h4 {
        font-size: 15px;
        margin-bottom: 8px;
        color: #e65100;
      }

      .important-note p {
        margin: 0;
        font-size: 14px;
        color: #e65100;
      }

      /* Purpose List */
      .purpose-list {
        display: flex;
        flex-direction: column;
        gap: 20px;
        margin: 24px 0;
      }

      .purpose-item {
        display: flex;
        gap: 20px;
        background: #f8f9fa;
        padding: 20px;
        border-radius: 12px;
      }

      .purpose-number {
        width: 40px;
        height: 40px;
        background: #E5332A;
        color: #fff;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 18px;
        font-weight: 700;
        flex-shrink: 0;
      }

      .purpose-content h3 {
        font-size: 16px;
        margin-bottom: 8px;
        color: #2B2B2B;
      }

      .purpose-content p {
        margin: 0;
        font-size: 14px;
        color: #495057;
      }

      /* Legal Bases */
      .legal-bases {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 16px;
        margin: 24px 0;
      }

      .legal-base-card {
        background: #f8f9fa;
        padding: 20px;
        border-radius: 12px;
        border-left: 4px solid #E5332A;
      }

      .legal-base-card h3 {
        font-size: 15px;
        margin-bottom: 12px;
        color: #2B2B2B;
      }

      .legal-base-card p {
        margin: 0;
        font-size: 14px;
        color: #495057;
      }

      /* Transfer Table */
      .transfer-table {
        border: 2px solid #e9ecef;
        border-radius: 12px;
        overflow: hidden;
        margin: 24px 0;
      }

      .transfer-row {
        display: grid;
        grid-template-columns: 1fr 2fr;
        border-bottom: 1px solid #e9ecef;
      }

      .transfer-row:last-child {
        border-bottom: none;
      }

      .transfer-row.header-row {
        background: #E5332A;
        color: #fff;
        font-weight: 700;
      }

      .transfer-cell {
        padding: 16px;
        font-size: 14px;
      }

      .transfer-row:not(.header-row):nth-child(even) {
        background: #f8f9fa;
      }

      /* Warning Box */
      .warning-box {
        display: flex;
        gap: 16px;
        background: #fff3e0;
        border-left: 4px solid #ff9800;
        padding: 20px;
        border-radius: 12px;
        margin: 24px 0;
      }

      .warning-box svg {
        color: #ff9800;
        flex-shrink: 0;
        margin-top: 4px;
      }

      .warning-box h4 {
        font-size: 15px;
        margin-bottom: 8px;
        color: #e65100;
      }

      .warning-box p {
        margin: 0;
        font-size: 14px;
        color: #e65100;
      }

      /* Collection Methods */
      .collection-methods {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 16px;
        margin: 24px 0;
      }

      .method-card {
        background: #f8f9fa;
        padding: 20px;
        border-radius: 12px;
        text-align: center;
        border: 2px solid #e9ecef;
      }

      .method-card h3 {
        font-size: 20px;
        margin-bottom: 12px;
      }

      .method-card p {
        margin: 0;
        font-size: 14px;
        color: #495057;
      }

      /* Rights Section */
      .highlight-section {
        background: #f0f9ff;
        padding: 32px;
        border-radius: 16px;
        border: 2px solid #bfdbfe;
      }

      .rights-grid {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 16px;
        margin: 24px 0;
      }

      .right-card {
        background: #fff;
        padding: 20px;
        border-radius: 12px;
        border: 2px solid #e9ecef;
        text-align: center;
      }

      .right-icon {
        width: 48px;
        height: 48px;
        background: #E5332A;
        color: #fff;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 20px;
        font-weight: 700;
        margin: 0 auto 16px;
      }

      .right-card h3 {
        font-size: 15px;
        margin-bottom: 12px;
        color: #2B2B2B;
      }

      .right-card p {
        margin: 0;
        font-size: 13px;
        color: #495057;
      }

      /* Application Methods */
      .application-methods {
        display: grid;
        gap: 20px;
        margin: 24px 0;
      }

      .application-card {
        background: #f8f9fa;
        padding: 24px;
        border-radius: 12px;
        border-left: 4px solid #E5332A;
      }

      .application-card h3 {
        font-size: 16px;
        margin-bottom: 12px;
        color: #2B2B2B;
      }

      .application-card p {
        margin-bottom: 8px;
        font-size: 14px;
      }

      .application-card .note {
        font-size: 13px;
        color: #868e96;
        margin-top: 12px;
      }

      /* Security Measures */
      .security-measures {
        display: grid;
        gap: 16px;
        margin: 24px 0;
      }

      .security-item {
        display: flex;
        align-items: flex-start;
        gap: 16px;
        background: #f8f9fa;
        padding: 16px;
        border-radius: 12px;
      }

      .security-item svg {
        color: #22c55e;
        flex-shrink: 0;
        margin-top: 4px;
      }

      .security-item h3 {
        font-size: 15px;
        margin-bottom: 6px;
        color: #2B2B2B;
      }

      .security-item p {
        margin: 0;
        font-size: 14px;
        color: #495057;
      }

      /* Retention Table */
      .retention-table {
        border: 2px solid #e9ecef;
        border-radius: 12px;
        overflow: hidden;
        margin: 24px 0;
      }

      .retention-row {
        display: grid;
        grid-template-columns: 2fr 1fr 2fr;
        border-bottom: 1px solid #e9ecef;
      }

      .retention-row:last-child {
        border-bottom: none;
      }

      .retention-row.header-row {
        background: #E5332A;
        color: #fff;
        font-weight: 700;
      }

      .retention-cell {
        padding: 16px;
        font-size: 14px;
      }

      .retention-row:not(.header-row):nth-child(even) {
        background: #f8f9fa;
      }

      /* Cookie Info */
      .cookie-info {
        background: #f8f9fa;
        padding: 24px;
        border-radius: 12px;
        margin: 24px 0;
      }

      .cookie-info h3 {
        font-size: 16px;
        margin-bottom: 16px;
        color: #2B2B2B;
      }

      .cookie-info ul {
        margin-bottom: 16px;
      }

      .cookie-info .note {
        font-size: 13px;
        color: #868e96;
        font-style: italic;
      }

      /* Update Notice */
      .update-notice {
        display: flex;
        align-items: center;
        gap: 12px;
        background: #e3f2fd;
        padding: 16px;
        border-radius: 12px;
        margin: 24px 0;
      }

      .update-notice svg {
        color: #2196f3;
        flex-shrink: 0;
      }

      .update-notice p {
        margin: 0;
        font-size: 14px;
        color: #1565c0;
      }

      /* Contact Section */
      .contact-section {
        background: #f8f9fa;
        padding: 32px;
        border-radius: 16px;
      }

      .final-contact-card {
        background: #fff;
        padding: 24px;
        border-radius: 12px;
        border: 2px solid #e9ecef;
        margin: 24px 0;
      }

      .contact-row {
        display: grid;
        grid-template-columns: 150px 1fr;
        padding: 12px 0;
        border-bottom: 1px solid #e9ecef;
        font-size: 14px;
      }

      .contact-row:last-child {
        border-bottom: none;
      }

      .contact-row strong {
        color: #868e96;
      }

      .contact-row span {
        color: #2B2B2B;
      }

      /* Document Footer */
      .document-footer {
        margin-top: 48px;
        padding-top: 32px;
        border-top: 2px solid #e9ecef;
        text-align: center;
      }

      .document-footer p {
        font-size: 14px;
        color: #868e96;
        margin-bottom: 12px;
      }

      .signature {
        font-size: 16px !important;
        color: #E5332A !important;
        font-weight: 700;
        margin: 24px 0 12px !important;
      }

      .effective-date {
        font-size: 13px !important;
        color: #868e96 !important;
        font-style: italic;
      }

      /* Responsive */
      @media (max-width: 992px) {
        .kvkk-modal-body {
          padding: 20px;
        }

        .data-categories,
        .legal-bases,
        .rights-grid {
          grid-template-columns: 1fr;
        }

        .contact-grid,
        .collection-methods {
          grid-template-columns: 1fr;
        }

        .transfer-row,
        .retention-row {
          grid-template-columns: 1fr;
        }

        .transfer-cell,
        .retention-cell {
          border-bottom: 1px solid #e9ecef;
        }

        .document-header h1 {
          font-size: 22px;
        }
      }

      @media (max-width: 768px) {
        .kvkk-modal-content {
          max-width: 100%;
          border-radius: 0;
          max-height: 100vh;
        }

        .kvkk-modal-body {
          padding: 16px;
          max-height: 100vh;
        }

        .contact-row {
          grid-template-columns: 1fr;
          gap: 4px;
        }
      }

      @media (max-width: 480px) {
        .kvkk-modal-content {
          max-width: 100%;
          border-radius: 0;
          max-height: 100vh;
        }

        .kvkk-modal-body {
          padding: 3px;
          max-height: 100vh;
        }

        .contact-row {
          grid-template-columns: 1fr;
          gap: 4px;
        }

        .modal-close-btn {
          width: 24px;
          height: 24px;
        }
      }
    `}</style>
    );
}